import { render, staticRenderFns } from "./Banners.vue?vue&type=template&id=2fd828f6&lang=pug&"
import script from "./Banners.vue?vue&type=script&lang=js&"
export * from "./Banners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports